import { format } from 'date-fns';
import { toWords } from 'number-to-words';

function numberToWords(num) {
  return toWords(num).replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalize words
}

export const formatDate = (dateStr, format = 'DD-MM-YYYY') => {
  if (!dateStr) return '';

  const date = new Date(dateStr);
  if (isNaN(date)) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  switch (format) {
    case 'DD-MM-YYYY':
      return `${day}-${month}-${year}`;
    case 'MM-DD-YYYY':
      return `${month}-${day}-${year}`;
    case 'YYYY-MM-DD':
      return `${year}-${month}-${day}`;
    default:
      return `${day}-${month}-${year}`;
  }
};

export const dateToWords = (dateString) => {
  if (!dateString) return 'Invalid Date';

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  const day = format(date, 'do');
  const month = format(date, 'LLLL');
  const year = format(date, 'yyyy');
  // const yearInWords = toWords(parseInt(year)).replace(/\b\w/g, c => c.toUpperCase());

  const formattedDay = day.charAt(0).toUpperCase() + day.slice(1);

  return `${formattedDay} ${month} ${year}`;
};

export function formatToAmPm(time24) {
  if (!time24) return '';

  // Expecting time24 as "HH:mm", e.g., "20:13"
  const [hoursStr, minutes] = time24.split(':');
  let hours = parseInt(hoursStr, 10);
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // convert 0 to 12 for 12 AM
  return `${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
}

export const LEAD_STATUS_COLORS = {
  'New Enquiry': 'bg-primary text-white',
  Contacted: 'bg-info text-dark',
  'Follow-Up Scheduled': 'bg-warning text-dark',
  Interested: 'bg-success text-white',
  'Counseling Done': 'bg-secondary text-white',
  'Application Form Filled': 'bg-info text-white',
  'Documents Submitted': 'bg-dark text-white',
  'Admission Confirmed': 'bg-success bg-gradient text-white',
  'Admission Deferred': 'bg-warning bg-gradient text-dark',
  'Not Interested': 'bg-danger bg-gradient text-white',
};

export const getToday = () => {
  return new Date().toISOString().split('T')[0];
};

export function addDuration(startDate, durationStr) {
  if (!durationStr) return startDate;

  const [valueStr, unitRaw] = durationStr.split(' ');
  const value = parseInt(valueStr);

  const unit = unitRaw.toLowerCase(); // normalize: "Years" → "years"

  const date = new Date(startDate);

  if (unit.startsWith('month')) {
    date.setMonth(date.getMonth() + value);
  } else if (unit.startsWith('year')) {
    date.setFullYear(date.getFullYear() + value);
  }

  // ✅ Always subtract 1 day
  date.setDate(date.getDate() - 1);

  return date.toISOString().split('T')[0]; // yyyy-mm-dd
}

export const showDefaultValue = (val, placeholder = '—') => {
  if (val === null || val === undefined || val === '') {
    return <span className='text-muted'>{placeholder}</span>;
  }
  return val;
};
